import React from 'react';

import LinkButton from '@atlaskit/button/link';

const LinkButtonPrimaryExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="primary" href="https://atlassian.com/">
			Primary link button
		</LinkButton>
	);
};

export default LinkButtonPrimaryExample;
